import {
  put, take, takeEvery, all, call,
} from 'redux-saga/effects';
import { channel } from 'redux-saga';
import AppApi from './app.api';
import ErrorFormatService from '../../services/error-format-service';
import {
  GET_BASE_DATA, GET_BASE_DATA_SUCCESS, GET_BASE_DATA_ERROR, USER_SESSION_EXPIRED_SUBSCRIBED_SUCCESS,
  SAVE_USER_PUSH_NOTIFICATION_TOKEN, SAVE_USER_PUSH_NOTIFICATION_TOKEN_SUCCESS, SAVE_USER_PUSH_NOTIFICATION_TOKEN_ERROR,
  USER_SESSION_EXPIRED, USER_SESSION_EXPIRED_SUCCESS, USER_SESSION_EXPIRED_ERROR,
} from '../../constants/system/actions';

const userSessionExpiredChannel: ReduxSagaChannel = channel();

export function* getBaseData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(AppApi.getBaseData, payload);
    yield put({ type: GET_BASE_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_BASE_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* saveUserPushNotificationToken(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(AppApi.saveUserPushNotificationToken, payload);
    yield put({ type: SAVE_USER_PUSH_NOTIFICATION_TOKEN_SUCCESS, data, payload });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: SAVE_USER_PUSH_NOTIFICATION_TOKEN_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* userSessionExpired(action: ReduxAction): Generator<ReduxAction> {
  const { payload } = action;

  try {
    const subscription: GraphQLSubscription = yield call(
      AppApi.userSessionExpired,
      payload,
      (data: ActionResponse): void => {
        userSessionExpiredChannel.put({ type: USER_SESSION_EXPIRED_SUCCESS, data });
      },
    );

    yield put({ type: USER_SESSION_EXPIRED_SUBSCRIBED_SUCCESS, subscription });
  } catch (error: GraphQLError) {
    yield put({ type: USER_SESSION_EXPIRED_ERROR, error });
  }
}

export function* watchUserSessionExpiredChannel(): Generator<ReduxAction> {
  while (true) {
    const action: ReduxAction = (yield take(userSessionExpiredChannel)) as ReduxAction;

    yield put(action);
  }
}

export default function* appSagas(): Generator<ReduxAction> {
  yield all([
    takeEvery(GET_BASE_DATA, getBaseData),
    takeEvery(SAVE_USER_PUSH_NOTIFICATION_TOKEN, saveUserPushNotificationToken),
    takeEvery(USER_SESSION_EXPIRED, userSessionExpired),
    takeEvery(USER_SESSION_EXPIRED, watchUserSessionExpiredChannel),
  ]);
}
